import React from 'react';
import { useRecoilValue } from 'recoil';
import { getDownloadLink } from '../../Shares/CommonUtil';
import { cdnUrlConfig } from '../../Utils/atoms';
/**
 * 2022년겨울 펫월드 인증샷 프로모션 페이지 (크리스마스)
 */
const PetWorldChristmas = () => {
    const isApp = window.location.pathname.includes("app") //URL에 "app"이 포함되면 true
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;

    return (
        <div id="wrap">
            <div className="container">
                <div className="content Christmas">
                    {/* 상단 비주얼 */}
                    <div className="visual">
                        <h1>
                            <img src={`${IMG_URL}/images/room/christmas/tit.png`} alt="/images/room/christmas/tit.png" />
                        </h1>
                        <p>펫스타그램에 겨울 펫월드 방문 인증하고<br /><span>#크리스마스</span> 해시태그 달고 젤리20개와 경품받자!</p>
                    </div>
                    {/* // 상단 비주얼 */}

                    {/* 이벤트 안내 */}
                    <div className="event-info detail">
                        <div className="tit-area">
                            <h2>
                                <span>이벤트 상세 안내</span>
                            </h2>
                        </div>
                        <ul className="info-list">
                            <li>
                                <div className="tit-info">참여기간</div>
                                <div className="txt">2022년 12월 1일 ~ 12월 31일</div>
                            </li>
                            <li>
                                <div className="tit-info">발표일</div>
                                <div className="txt">2023년 1월 7일</div>
                            </li>
                            <li>
                                <div className="tit-info">지급대상</div>
                                <div className="txt">펫스타그램에 #크리스마스 해시태그와 겨울 펫월드 인증샷 게시물을 함께 올린 사용자 중 좋아요 숫자를 가장 많이 받은 1등, 2등, 3등과 이벤트 참가자 전원</div>
                            </li>
                        </ul>
                    </div>
                    {/* // 이벤트 안내 */}

                    {/* 경품안내 */}
                    <div className="event-info product">
                        <div className="tit-area">
                            <h2>경품안내</h2>
                        </div>
                        <div className="product-area">
                            <ol>
                                <li>
                                    <div className="photo">
                                        <div className="ranking">1등</div>
                                        <figure>
                                            <img src={`${IMG_URL}/images/room/christmas/img_product1.png`} alt="/images/room/christmas/img_product1.png" />
                                            <figcaption>문화상품권 5만원권</figcaption>
                                        </figure>
                                    </div>
                                    <div className="name">문화상품권 5만원권 (1명) <span>컬쳐랜드 문화상품권</span></div>
                                </li>
                                <li>
                                    <div className="photo">
                                        <div className="ranking">2등</div>
                                        <figure>
                                            <img src={`${IMG_URL}/images/room/christmas/img_product2.png`} alt="/images/room/christmas/img_product2.png" />
                                            <figcaption>문화상품권 3만원권</figcaption>
                                        </figure>
                                    </div>
                                    <div className="name">문화상품권 3만원권 (1명) <span>컬쳐랜드 문화상품권</span></div>
                                </li>
                                <li>
                                    <div className="photo">
                                        <div className="ranking">3등</div>
                                        <figure>
                                            <img src={`${IMG_URL}/images/room/christmas/img_product3.png`} alt="/images/room/christmas/img_product3.png" />
                                            <figcaption>문화상품권 1만원권</figcaption>
                                        </figure>
                                    </div>
                                    <div className="name">문화상품권 1만원권 (1명) <span>컬쳐랜드 문화상품권</span></div>
                                </li>
                            </ol>
                            <dl className="tip">
                                <dt>참가자 전원</dt>
                                <dd>
                                    <span>젤리</span> <strong>20</strong>개 지급!
                                </dd>
                            </dl>
                        </div>
                    </div>
                    {/* // 경품안내 */}

                    {/* 참여방법 */}
                    <div className="event-info howto">
                        <div className="tit-area">
                            <h2>참여 안내</h2>
                        </div>
                        <ol>
                            <li>
                                <div className="num">1</div>
                                <div className="txt">겨울 펫월드인 ‘gg페스타’, ‘캠핑장’, ‘무도회장’ 증<br />하나를 방문해서 나의 캐릭터 모습 캡처하기</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/christmas/img_guide1.png`} alt="/images/room/christmas/img_guide1.png" />
                                    </figure>
                                    <figcaption>비글즈 앱 겨웃 펫월드 캡처</figcaption>
                                </div>
                            </li>
                            <li>
                                <div className="num">2</div>
                                <div className="txt">우측 상단의 + 버튼 클릭 후 펫월드 사진 올리기</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/christmas/img_guide2.png`} alt="/images/room/christmas/img_guide2.png" />
                                    </figure>
                                    <figcaption>하단 콘테스트 참여하기</figcaption>
                                </div>
                            </li>
                            <li>
                                <div className="num">3</div>
                                <div className="txt">겨울 펫월드 인증샷과 <strong>#크리스마스</strong> 해시태그를 달아<br />게시물 업로드</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/christmas/img_guide3.png`} alt="/images/room/christmas/img_guide3.png" />
                                    </figure>
                                    <figcaption>게시물 업로드</figcaption>
                                </div>
                            </li>
                        </ol>
                    </div>
                    {/* // 참여방법 */}

                    {/* 안내 */}
                    <div className="cautionary">
                        <dl>
                            <dt>확인해주세요!</dt>
                            <dd>이벤트에 당첨되신 분들은 꼭 담청자 발표 7일 이내로 마이페이지 &gt; 설정 &gt; 고객센터 1:1 문의 접수 혹은 운영자 이메일 개별 연락을 통해 휴대전화 번호를 보내주셔야 합니다.</dd>
                            <dd>펫월드 인증샷과 #해시태그를 함께 올리시지 않으신 분은 참여 무효 처리 됩니다.</dd>
                            <dd>해당 이벤트는 사용자 1명이 여러 게시물을 올리실 수 있으시나, 중복 당첨은 불가합니다.</dd>
                            <dd>기간 내 이벤트 수령을 원하시는 휴대전화번호를 보내주시지 않을 경우 당첨이 취소될 수 있습니다.</dd>
                            <dd>이벤트 기간 동안 닉네임 변경 시 당첨 정보 확인이 불가하여 당첨이 취소될 수 있습니다.</dd>
                            <dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
                            <dd>잘못된 정보로 인해 상품을 받지 못할 경우에는 재전송이 불가합니다.</dd>
                        </dl>
                    </div>
                    {/* // 안내 */}
                    {
                        isApp ?
                            <>
                                {/* copyright - 인앱 */}
                                <div className="copy">
                                    <img src={`${IMG_URL}/images/gameking/logo.png`} alt="/images/gameking/logo.png" />
                                </div>
                            </>
                            :
                            <>
                                {/* 다운로드 버튼 - bigglz 홈페이지(프로모션) */}
                                <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer" className='btn-download'>
                                    <i></i>앱 다운로드 하러가기
                                </a>
                            </>
                    }
                </div>
            </div>
        </div>
    );
}

export default PetWorldChristmas;